module.exports = __webpack_public_path__ + "static/media/icon-scheduling-config.b78b6dd2.svg";